// ─── DAZZLE MONTREAL — COMPLETE JS ───────────────────────────────────────


// ── TOAST NOTIFICATION ──
function dzToast(msg, type){
  var t = document.getElementById('dz-toast');
  if(!t){
    t = document.createElement('div');
    t.id = 'dz-toast';
    t.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#111;color:#fff;padding:10px 20px;border-radius:4px;font-size:12px;font-weight:700;letter-spacing:.05em;z-index:2000;opacity:0;transition:opacity .25s;pointer-events:none;white-space:nowrap;max-width:90vw;text-align:center';
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.style.background = type === 'error' ? '#c0392b' : type === 'success' ? '#27ae60' : '#111';
  t.style.opacity = '1';
  clearTimeout(t._timer);
  t._timer = setTimeout(function(){ t.style.opacity = '0'; }, 3000);
}

// ── MONEY FORMAT (uses shop.money_format injected via theme.liquid) ──
function dzMoney(cents){
  var fmt = window.dzMoneyFmt || '${{amount}}';
  var n = (cents / 100).toFixed(2);
  var parts = n.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  var formatted = parts.join('.');
  return fmt.replace('{{amount}}', formatted)
            .replace('{{amount_no_decimals}}', Math.round(cents/100))
            .replace('{{amount_with_comma_separator}}', formatted.replace('.',','));
}

function dzInitSlider(){}

// ── CART DRAWER ──
function dzCart(){
  var d = document.getElementById('dz-cart-drawer');
  var o = document.getElementById('dz-cart-ov');
  if(!d) return;
  var opening = !d.classList.contains('open');
  d.classList.toggle('open');
  if(o) o.classList.toggle('open');
  document.body.style.overflow = d.classList.contains('open') ? 'hidden' : '';
  if(opening) dzRefreshCartDrawer();
}

// ── REFRESH CART DRAWER ──
function dzRefreshCartDrawer(){
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
    // Update badge
    var badge = document.getElementById('dz-cart-count');
    if(badge) badge.textContent = cart.item_count;

    // Update item count in title
    var titleSpan = document.querySelector('.cart-title span');
    if(titleSpan) titleSpan.textContent = '(' + cart.item_count + ')';

    // Update shipping bar
    var thresh = window.dzFreeShipThresh || 7500;
    var pct = Math.min(100, Math.round(cart.total_price / thresh * 100));
    var fill = document.querySelector('.ship-fill');
    var msg  = document.querySelector('.ship-msg');
    if(fill) fill.style.width = pct + '%';
    if(msg){
      if(cart.total_price >= thresh){
        msg.innerHTML = '<strong style="color:#27ae60">You unlocked FREE shipping! &#128666;</strong>';
      } else {
        var rem = dzMoney(thresh - cart.total_price);
        msg.innerHTML = 'Add <strong>' + rem + '</strong> more for <strong>FREE shipping!</strong>';
      }
    }

    // Update total
    var total = document.querySelector('.cart-total-row strong');
    if(total) total.textContent = dzMoney(cart.total_price);

    // Rebuild cart items
    var itemsEl = document.querySelector('.cart-items');
    if(!itemsEl) return;
    if(cart.item_count === 0){
      itemsEl.innerHTML = '<div style="text-align:center;padding:48px 20px;color:#888;font-size:14px">Your cart is empty</div>';
      return;
    }

    /* B2G1: find cheapest item key(s) — 1 free per every 3 items */
    var freeKeys = {};
    if(cart.item_count >= 3){
      /* Expand items into individual units sorted by price ascending */
      var units = [];
      cart.items.forEach(function(item){
        for(var q = 0; q < item.quantity; q++){
          units.push({key: item.key, price: item.price});
        }
      });
      units.sort(function(a,b){ return a.price - b.price; });
      /* Every 3rd unit (0, 3, 6...) is free */
      var freeSets = Math.floor(units.length / 3);
      for(var i = 0; i < freeSets; i++){
        freeKeys[units[i].key] = (freeKeys[units[i].key] || 0) + 1;
      }
    }

    var html = '';
    cart.items.forEach(function(item){
      var imgStyle = item.image
        ? 'background:url(' + encodeURI(item.image) + ') center/cover no-repeat,#f5f5f5'
        : 'background:linear-gradient(160deg,#FFDCE5,#DDF2FF)';
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="ci-var">' + item.variant_title + '</div>' : '';
      var freeQty = freeKeys[item.key] || 0;
      var priceHtml;
      if(freeQty > 0 && item.quantity === 1){
        priceHtml = '<div class="ci-price"><span class="ci-was">' + dzMoney(item.price) + '</span> <span class="ci-free">FREE</span></div>';
      } else if(freeQty > 0){
        var paidQty = item.quantity - freeQty;
        var paidTotal = paidQty * item.price;
        priceHtml = '<div class="ci-price">' + dzMoney(paidTotal) + ' <span class="ci-free">+' + freeQty + ' FREE</span></div>';
      } else {
        priceHtml = '<div class="ci-price">' + dzMoney(item.final_line_price) + '</div>';
      }
      html += '<div class="ci">' +
        '<div class="ci-img"><div class="bg" style="' + imgStyle + ';width:100%;height:100%"></div></div>' +
        '<div class="ci-info">' +
          '<div class="ci-name">' + (item.product_title||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;') + '</div>' +
          variantLine +
          '<div class="ci-row">' +
            '<div class="ci-qty">' +
              '<button onclick="dzQtyDown(\'' + item.key + '\',' + item.quantity + ')">&#8722;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button onclick="dzChangeQty(\'' + item.key + '\',' + (item.quantity+1) + ')">&#43;</button>' +
            '</div>' +
            priceHtml +
          '</div>' +
          '<span class="ci-remove" onclick="dzChangeQty(\'' + item.key + '\',0)">Remove</span>' +
        '</div>' +
      '</div>';
    });
    itemsEl.innerHTML = html;
  });
}

// ── ADD TO CART (from grids / quick-add) ──
function dzAddToCart(id, qty, btn){
  qty = qty || 1;
  var orig = btn ? btn.textContent : null;
  if(btn){ btn.textContent = 'Adding...'; btn.style.opacity = '.7'; }
  fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: id, quantity: qty})})
  .then(function(r){ return r.json(); })
  .then(function(){
    if(btn){ btn.textContent = 'Added!'; btn.style.opacity = '1';
      setTimeout(function(){ btn.textContent = orig; }, 1800); }
    dzRefreshCartDrawer();
    // Open cart drawer if not already open
    var d = document.getElementById('dz-cart-drawer');
    if(d && !d.classList.contains('open')) dzCart();
  }).catch(function(err){
    console.error('Add to cart failed:', err);
    if(btn){ btn.textContent = orig || 'Add to Cart'; btn.style.opacity = '1'; }
    dzToast('Could not add to cart. Please try again.', 'error');
  });
}

// ── DEBOUNCE HELPER ──
function dzDebounce(fn, delay){
  var timer;
  return function(){
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function(){ fn.apply(null, args); }, delay);
  };
}
var dzChangeQtyDebounced = null;

// ── QTY DOWN (with remove guard) ──
function dzQtyDown(key, current){
  if(current <= 1){
    if(!confirm('Remove this item?\nRetirer cet article?')) return;
  }
  dzChangeQty(key, current - 1);
}

// ── CHANGE QTY IN CART ──
function dzChangeQty(key, qty){
  /* Runs immediately — debounce happens at the call site via dzQtyDown/up */
  /* Find the button/element that triggered this and show loading state */
  fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: key, quantity: qty})})
  .then(function(r){
    if(!r.ok) throw new Error('Cart error: ' + r.status);
    return r.json();
  })
  .then(function(cart){
    dzRefreshCartDrawer();
    var badge = document.getElementById('dz-cart-count');
    if(badge) badge.textContent = cart.item_count;
  })
  .catch(function(err){
    console.error('dzChangeQty failed:', err);
    dzRefreshCartDrawer();
  })
  .finally(function(){
    /* Re-enable buttons after response */
    document.querySelectorAll('.ci-qty button, .ci-remove').forEach(function(b){ b.style.opacity=''; b.style.pointerEvents=''; });
  });
}

// ── MOBILE MENU ──
function dzMenu(){
  var d = document.getElementById('dz-mob-drawer');
  var o = document.getElementById('dz-mob-ov');
  if(!d) return;
  d.classList.toggle('open');
  if(o) o.classList.toggle('open');
  document.body.style.overflow = d.classList.contains('open') ? 'hidden' : '';
}
function dzSub(el){
  el.classList.toggle('expanded');
  var s = el.nextElementSibling;
  if(s && s.classList.contains('md-sub')) s.classList.toggle('open');
}

// ── RESET BODY OVERFLOW ON NAV ──
window.addEventListener('pagehide', function(){ document.body.style.overflow = ''; });

// ── HEADER SCROLL SHADOW ──
window.addEventListener('scroll', function(){
  var h = document.querySelector('.header');
  if(h) h.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,.08)' : 'none';
});

// ── EMAIL POPUP ──
setTimeout(function(){
  var p = document.getElementById('dz-popup');
  if(!p) return;
  var shown = localStorage.getItem('dz_popup_shown');
  var now = Date.now();
  var sevenDays = 7 * 24 * 60 * 60 * 1000;
  var shownTime = parseInt(shown);
  /* Validate it's a real timestamp (after 2020) not legacy '1' value */
  var validTimestamp = shownTime > 1577836800000;
  if(!shown || !validTimestamp || (now - shownTime) > sevenDays){
    p.classList.add('open');
    localStorage.setItem('dz_popup_shown', String(now));
  }
}, (window.dzPopupDelay || 30) * 1000);

// ── ACCORDION ──
document.addEventListener('click', function(e){
  var head = e.target.closest('.acc-head');
  if(head) head.parentElement.classList.toggle('open');
});


// ── WISHLIST (global — grid cards) ──
var DZ_WISH_KEY = 'dz_wishlist';
function dzGetWishlist(){ try{ return JSON.parse(localStorage.getItem(DZ_WISH_KEY)||'[]'); }catch(e){ return []; } }
function dzSaveWishlist(list){ try{ localStorage.setItem(DZ_WISH_KEY,JSON.stringify(list)); }catch(e){} }
function dzToggleWishCard(el, productId){
  var list = dzGetWishlist();
  var idx = list.indexOf(productId);
  if(idx === -1){
    list.push(productId);
    el.innerHTML = '&#9829;';
    el.style.color = '#c8427a';
    el.style.background = 'rgba(200,66,122,.12)';
  } else {
    list.splice(idx,1);
    el.innerHTML = '&#9825;';
    el.style.color = '';
    el.style.background = '';
  }
  dzSaveWishlist(list);
}

// ── SEARCH ICON → navigate to search ──
document.addEventListener('DOMContentLoaded', function(){
  // Close mobile drawer when any link inside it is clicked
  var drawer = document.getElementById('dz-mob-drawer');
  if(drawer){
    drawer.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        var d = document.getElementById('dz-mob-drawer');
        var o = document.getElementById('dz-mob-ov');
        if(d && d.classList.contains('open')){
          d.classList.remove('open');
          if(o) o.classList.remove('open');
          document.body.style.overflow = '';
        }
      });
    });
  }

  dzInitSlider();

  // Close popup when clicking overlay
  var popupOv = document.getElementById('dz-popup');
  if(popupOv){
    popupOv.addEventListener('click', function(e){
      if(e.target === popupOv) popupOv.classList.remove('open');
    });
  }

  // Wire up search icon if it's a div not an <a>
  var searchHico = document.querySelector('.hico[title="Search"]');
  if(searchHico && searchHico.tagName !== 'A'){
    searchHico.style.cursor = 'pointer';
    searchHico.addEventListener('click', function(){ window.location = '/search'; });
  }

  // Wishlist heart on product cards — persists via localStorage
  document.addEventListener('click', function(e){
    var wish = e.target.closest('.wish');
    if(!wish) return;
    e.preventDefault();
    var pid = parseInt(wish.dataset.productId || '0');
    if(pid) dzToggleWishCard(wish, pid);
    else {
      // Fallback: just toggle visual if no product ID
      var filled = wish.innerHTML.indexOf('9829') !== -1;
      wish.innerHTML = filled ? '&#9825;' : '&#9829;';
      wish.style.color = filled ? '' : '#c8427a';
    }
  });
  // Init wishlist state on page load
  var wishCards = document.querySelectorAll('.wish[data-product-id]');
  var wl = dzGetWishlist();
  wishCards.forEach(function(w){
    var pid = parseInt(w.dataset.productId||'0');
    if(pid && wl.indexOf(pid) !== -1){
      w.innerHTML = '&#9829;';
      w.style.color = '#c8427a';
      w.style.background = 'rgba(200,66,122,.12)';
    }
  });
});
